import { render, staticRenderFns } from "./addOrder.vue?vue&type=template&id=5dcb89fc&scoped=true"
import script from "./addOrder.vue?vue&type=script&lang=js"
export * from "./addOrder.vue?vue&type=script&lang=js"
import style0 from "./addOrder.vue?vue&type=style&index=0&id=5dcb89fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_a0b2c34ca8cb6aec36211e2e48fb208b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb89fc",
  null
  
)

export default component.exports